import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTridentComponent } from "./med-icon-trident.component";

@NgModule({
  declarations: [
    MedIconTridentComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTridentComponent,
  ],
})
export class MedIconTridentModule { }
